<!-- pageName -->
<template>
  <div class="wrapper">
    <ul class="ul_icons ul_bg">
      <li class="cloud_platform" v-for="item in blocks" :key="item.id" @click="toUrl(item.tzurl)">
        <!-- <a>
          <div class="div_img">
            <img :src="item.bgimg" alt="" />
            <img :src="item.imgbz" alt="" />
          </div>
        </a>
        <span
          ><p>{{ item.title }}</p>
        </span> -->
        <div class="div_img">
          <img :src="item.bgimg" alt="" />
        </div>
        <span
          ><p>{{ item.title }}</p>
        </span>
        <div class="div_fix" v-if="item.imgbz">
          <img :src="item.imgbz" alt="" />
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    blocks: {
      type: Array,
      default: () => [],
    },
  },
  components: {},
  data() {
    return {}
  },
  computed: {},
  watch: {},
  methods: {
    toUrl(url) {
      if (url) {
        window.open(url)
      }
    },
  },
  created() {},
  mounted() {}
}
</script>

<style lang="less" scoped>
/* @import url(); 引入css类 */
.cloud_platform{
  cursor: pointer;
}
// 去掉二维码显示
.ul_icons li:hover .div_img img:nth-child(1) {
  display: block;
  background: none;
}
.role .ul_icons li:nth-child(1):hover .div_fix img, .role .ul_icons li:nth-child(4):hover .div_fix img {
  display: none;
  background: red;
}
</style>
